import { integrityHashes } from '../../../../../../onetrust-hashes.config.json'

export const ONETRUST_SDK_INTEGRITY_HASHES = integrityHashes
